<template>
    <div class="filter-slider-box">
        <p class="mb-2" v-if="showTitle"><b>{{ getTitle }}</b></p>
        <p class="filter-reset-icon" v-if="hasChanged">
            <font-awesome-icon icon="fa-minus-circle" class="text-link" @click="resetFilter" />
        </p>
        <div class="form-group relative">
            <div class="row">
                <div class="col-12">
                    <b-skeleton v-if="isLoading && value === null" height="14px" width="100%" class="mb-3"></b-skeleton>
                    <vue-slider :min="min" :max="max + 1" v-model="value" :enableCross="false" class="mb-3" v-on:change="update()"
                        silent lazy tooltip="none"></vue-slider>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex justify-content-between" v-if="isLoading">
                    <b-skeleton height="1rem" width="20%"></b-skeleton>
                    <b-skeleton height="1rem" width="20%"></b-skeleton>
                </div>
                <div class="col-12 d-flex justify-content-between" v-if="!isLoading">
                    <span>{{ getMinValue }}</span>
                    <span>{{ getMaxValue }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BSkeleton } from "bootstrap-vue"
import { EventBus } from "../../event-bus"
import VueSlider from "vue-slider-component";

export default {
    name: 'FilterSliderBox',
    components: {
        BSkeleton,
        VueSlider
    },
    props: {
        filterTitle: {
            type: String
        },
        appendContent: {
            type: String
        },
        showTitle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasChanged: false,
            changedByUrl: false,
            filterData: null,
            value: [0, 9999],
            min: 1,
            max: 9999,
            isLoading: true,
        }
    },
    methods: {
        validateNumber(p) {
            let d = this.value[p];
            this.value[p] = d.replace(/\D/g, '');
        },

        getFilterData(data) {
            this.filterData = data.find(f => f.name === this.filterTitle)
            this.max = this.filterData.interval_max

            if (this.$route.query[this.filterTitle]) {
                this.changedByUrl = true
                const values = this.$route.query[this.filterTitle].replace(/[^0-9\,]/g, '').split(',')

                if (values.length == 1 && values[0] == "1") {
                        this.value = [0, this.max]
                    } else {
                        this.hasChanged = true
                        if (values[0] > this.max || values[1] > this.max) {
                            this.value = [0, this.max]
                        } else {
                            this.value = values
                        }
                    }
            } else {
                this.value = [0, this.max]
            }

            this.isLoading = false
        },
        resetFilter() {
            this.hasChanged = false
            this.value = [0, this.max]
            this.changedByUrl = true

            EventBus.$emit('update-catalog-filter', { filter: this.filterTitle, value: `-1` })
        },
        update() {
            EventBus.$emit('update-catalog-filter', { filter: this.filterTitle, value: `[${this.value[0]},${this.value[1]}]` })
        }
    },
    computed: {
        getTitle() {
            return this.filterTitle ? `${this.$t('cat.filter.' + this.filterTitle)}` : ''
        },
        getMinValue() {
            return this.value ? this.$root.whitelabel.getFormatetPrice(this.value[0]) : ''
        },
        getMaxValue() {
            return this.value ? this.$root.whitelabel.getFormatetPrice(this.value[1]) : ''
        },
    },
    mounted() {
        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-received-modal', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
